export default "__VITE_ASSET__C_TAWN2Q__"